import React from 'react';
import Image from 'next/image';

interface CoreValueCardProps {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

/**
 * CoreValueCard Component
 * Displays a card with image and text for core values (Vision, Mission, Core Values)
 */
const CoreValueCard: React.FC<CoreValueCardProps> = ({ 
  title, 
  description, 
  imageSrc, 
  imageAlt 
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
      <div className="relative h-[250px] w-full">
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          className="object-cover"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          priority={false}
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-3">
          {title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

export default CoreValueCard;
